/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};
if (!rtAPI.accessibility) rtAPI.accessibility = {};
if (!rtAPI.accessibility.call) rtAPI.accessibility.call = {};

//#region API endpoint wrapper

rtAPI.accessibility.call.APIEndPoint = async function (command, data) {
    return await rtAPI.call.APIEndPoint('accessibility', command, data, true, true);
};

//#endregion

//#region Public methods

/**
 * Get the current accessibility theme enum name.
 * Returns header.data.currentTheme (string).
 */
rtAPI.accessibility.call.getCurrentTheme = async function () {
    return await this.APIEndPoint('get-current-theme');
};

/**
 * Get the current accessibility theme data attribute.
 * Returns header.data.currentThemeDataAttribute (string).
 */
rtAPI.accessibility.call.getCurrentThemeDataAttribute = async function () {
    return await this.APIEndPoint('get-current-theme-data-attribute');
};

//#endregion